import React, { useRef, useState } from "react";
import Alerts from "../util/Alerts";
import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardTitle,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import Select from "react-select";
import Datetime from "react-datetime";
import Switch from "react-bootstrap-switch";
import BlkDropImg from "../coms/BlkDropImg";
import ReactTable from "react-table";
import { SiniestrosEstados } from "../coms/siniestros/SiniestrosEstados";

export const Demo = ({ ...props }) => {
    const alert = useRef();

    const [tab, setTab] = useState("ht0");
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    return (
        <div className="content">
            <Alerts ref={alert} />
            <SiniestrosEstados historial={[]} fecha={new Date()} />
            <Card>
                <CardHeader>
                    <CardTitle tag="h4">Demo Estilos</CardTitle>
                </CardHeader>
                <CardBody>
                    <div className="container">
                        <Nav tabs className="text-center">
                            <NavItem className="flex-grow-1">
                                <NavLink className={tab === "ht0" ? "active" : ""} onClick={() => setTab("ht0")}>
                                    General
                                </NavLink>
                            </NavItem>
                            <NavItem className="flex-grow-1">
                                <NavLink className={tab === "ht1" ? "active" : ""} onClick={() => setTab("ht1")}>
                                    Forms
                                </NavLink>
                            </NavItem>
                            <NavItem className="flex-grow-1">
                                <NavLink className={tab === "ht2" ? "active" : ""} onClick={() => setTab("ht2")}>
                                    Buttons
                                </NavLink>
                            </NavItem>
                            <NavItem className="flex-grow-1">
                                <NavLink className={tab === "ht3" ? "active" : ""} onClick={() => setTab("ht3")}>
                                    Tables
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div>
                    <TabContent activeTab={tab} className="tab-space">
                        <TabPane tabId="ht0">
                            <div className="container my-4">
                                <h4 className="text-primary">Typography</h4>
                                <div className="row">
                                    <div className="col-6">
                                        <h1>Heading 1</h1>
                                        <h2>Heading 2</h2>
                                        <h3>Heading 3</h3>
                                        <h4>Heading 4</h4>
                                        <h5>Heading 5</h5>
                                        <h6>Heading 6</h6>

                                        <br />
                                        <p className="text-left">Left aligned text.</p>
                                        <p className="text-center">Center aligned text.</p>
                                        <p className="text-right">Right aligned text.</p>
                                    </div>
                                    <div className="col-6">
                                        <p>The following is rendered as normal weight text.</p>
                                        <p>
                                            The following is <strong>rendered as bold text</strong>.
                                        </p>
                                        <p>
                                            The following is{" "}
                                            <span className="font-weight-light">rendered as light weight</span>.
                                        </p>
                                        <p>
                                            The following is <em>rendered as italicized text</em>.
                                        </p>
                                        <p>
                                            An abbreviation of the word attribute is <abbr title="attribute">attr</abbr>
                                            .
                                        </p>
                                        <p>
                                            The following is rendered as <small>small text</small>.
                                        </p>
                                        <p>
                                            The following is <a href="#">rendered as link</a>.
                                        </p>
                                    </div>
                                </div>

                                <hr />
                                <div className="row">
                                    <div className="col-6">
                                        <h4 className="text-primary">Text Colors</h4>
                                        <p className="text-primary">.text-primary</p>
                                        <p className="text-secondary">.text-secondary</p>
                                        <p className="text-success">.text-success</p>
                                        <p className="text-danger">.text-danger</p>
                                        <p className="text-warning">.text-warning</p>
                                        <p className="text-info">.text-info</p>
                                        <p className="text-light bg-dark">.text-light</p>
                                        <p className="text-dark">.text-dark</p>
                                        <p className="text-body">.text-body</p>
                                        <p className="text-muted">.text-muted</p>
                                        <p className="text-white bg-dark">.text-white</p>
                                        <p className="text-black-50">.text-black-50</p>
                                        <p className="text-white-50 bg-dark">.text-white-50</p>
                                    </div>
                                    <div className="col-6">
                                        <h4 className="text-primary">Background color</h4>
                                        <div className="p-3 mb-2 bg-primary text-white">.bg-primary</div>
                                        <div className="p-3 mb-2 bg-secondary text-white">.bg-secondary</div>
                                        <div className="p-3 mb-2 bg-success text-white">.bg-success</div>
                                        <div className="p-3 mb-2 bg-danger text-white">.bg-danger</div>
                                        <div className="p-3 mb-2 bg-warning text-dark">.bg-warning</div>
                                        <div className="p-3 mb-2 bg-info text-white">.bg-info</div>
                                        <div className="p-3 mb-2 bg-light text-dark">.bg-light</div>
                                        <div className="p-3 mb-2 bg-dark text-white">.bg-dark</div>
                                        <div className="p-3 mb-2 bg-white text-dark">.bg-white</div>
                                        <div className="p-3 mb-2 bg-transparent text-dark">.bg-transparent</div>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tabId="ht1">
                            <div className="container my-4">
                                <div className="row">
                                    <div className="col-6">
                                        <form className="">
                                            <div className="form-group">
                                                <label>Plain Text</label>
                                                <input
                                                    type="text"
                                                    value="Some plain text/ static value"
                                                    className="form-control-plaintext"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Text</label>
                                                <input
                                                    type="text"
                                                    name="text"
                                                    placeholder="with a placeholder"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Password</label>
                                                <input
                                                    type="password"
                                                    name="password"
                                                    placeholder="password placeholder"
                                                    className="form-control"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>React select</label>
                                                <Select
                                                    defaultValue={[{ value: "1", label: "Chocolate" }]}
                                                    isMulti
                                                    name="colors"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    options={[
                                                        { value: "1", label: "Chocolate" },
                                                        { value: "2", label: "Strawberry" },
                                                        { value: "3", label: "Vanilla" },
                                                        { value: "4", label: "Vanilla" },
                                                        { value: "5", label: "Vanilla" },
                                                    ]}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>React Datetime</label>
                                                <Datetime />
                                            </div>

                                            <div className="form-group">
                                                <label>Image input</label>
                                                <BlkDropImg
                                                    maxSize={2 * 1024 * 1024}
                                                    accept="image/jpeg"
                                                    data="https://mocah.org/thumbs/4500719-wlop-blonde-anime-girls-violet-evergarden-violet-evergarden-anime.jpg"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Select</label>
                                                <select name="select" className="form-control">
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                </select>
                                            </div>
                                            <FormGroup>
                                                <label>Select Multiple</label>
                                                <Input type="select" name="selectMulti" multiple>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                </Input>
                                            </FormGroup>

                                            <div className="form-group">
                                                <label>Text Area</label>
                                                <textarea name="text" rows={4} className="form-control" />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Large input</label>
                                            <input
                                                className="form-control form-control-lg"
                                                type="text"
                                                placeholder=".form-control-lg"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Default input</label>
                                            <input className="form-control" type="text" placeholder="Default input" />
                                        </div>
                                        <div className="form-group">
                                            <label>Small input</label>
                                            <input
                                                className="form-control form-control-sm"
                                                type="text"
                                                placeholder=".form-control-sm"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Readonly</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Readonly input here…"
                                                readOnly
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Disabled input</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Disabled input"
                                                disabled
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Disabled select menu</label>
                                            <select className="form-control" disabled>
                                                <option>Disabled select</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label>Example Range input</label>
                                            <input type="range" className="form-control-range" />
                                        </div>

                                        <div className="form-group">
                                            <label>Input group</label>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    aria-label="Amount (to the nearest dollar)"
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">.00</span>
                                                </div>
                                            </div>

                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <button type="button" className="btn btn-primary  py-0 px-2">
                                                        Action
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split py-0 px-2"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        <span className="sr-only">Toggle Dropdown</span>
                                                    </button>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" href="#">
                                                            Action
                                                        </a>
                                                        <a className="dropdown-item" href="#">
                                                            Another action
                                                        </a>
                                                        <a className="dropdown-item" href="#">
                                                            Something else here
                                                        </a>
                                                        <div role="separator" className="dropdown-divider" />
                                                        <a className="dropdown-item" href="#">
                                                            Separated link
                                                        </a>
                                                    </div>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    aria-label="Text input with segmented dropdown button"
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className="d-block">Checkbox</label>
                                            <div className="form-check form-check-inline">
                                                <label className="form-check-label">
                                                    <input type="checkbox" className="form-check-input" />
                                                    Check me out
                                                    <span className="form-check-sign" />
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline disabled">
                                                <label className="form-check-label">
                                                    <input type="checkbox" className="form-check-input" disabled />
                                                    Check me out
                                                    <span className="form-check-sign" />
                                                </label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className="d-block">Radiobutton</label>
                                            <div className="form-check-radio form-check form-check-inline">
                                                <label className="form-check-label">
                                                    <input
                                                        name="exampleRadios"
                                                        type="radio"
                                                        className="form-check-input"
                                                        value="option1"
                                                        checked
                                                    />
                                                    Radio is on
                                                    <span className="form-check-sign" />
                                                </label>
                                            </div>
                                            <div className="form-check-radio form-check form-check-inline">
                                                <label className="form-check-label">
                                                    <input
                                                        name="exampleRadios"
                                                        type="radio"
                                                        className="form-check-input"
                                                        value="option1"
                                                    />
                                                    Radio is off
                                                    <span className="form-check-sign" />
                                                </label>
                                            </div>
                                            <div className="form-check-radio form-check form-check-inline disabled">
                                                <label className="form-check-label">
                                                    <input
                                                        name="exampleRadios"
                                                        type="radio"
                                                        className="form-check-input"
                                                        value="option2"
                                                        disabled
                                                    />
                                                    Radio is disabled
                                                    <span className="form-check-sign" />
                                                </label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className="d-block">Bootstrap switch</label>
                                            <Switch name="test" bsSize="normal" onChange={() => null} />
                                            <Switch
                                                name="test"
                                                onColor="success"
                                                offColor="danger"
                                                onText="SI"
                                                offText="NO"
                                                onChange={() => null}
                                            />
                                            <Switch name="test" bsSize="small" onChange={() => null} />
                                            <Switch name="test" bsSize="mini" onChange={() => null} />
                                            <Switch name="test" disabled onChange={() => null} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tabId="ht2">
                            <div className="container my-4">
                                <div className="row">
                                    <div className="col">
                                        <p>
                                            <button type="button" className="btn btn-primary">
                                                Primary
                                            </button>
                                            <button type="button" className="btn btn-secondary">
                                                Secondary
                                            </button>
                                            <button type="button" className="btn btn-success">
                                                Success
                                            </button>
                                            <button type="button" className="btn btn-info">
                                                Info
                                            </button>
                                            <button type="button" className="btn btn-warning">
                                                Warning
                                            </button>
                                            <button type="button" className="btn btn-danger">
                                                Danger
                                            </button>
                                            <button type="button" className="btn btn-light">
                                                Light
                                            </button>
                                            <button type="button" className="btn btn-dark">
                                                Dark
                                            </button>
                                            <button type="button" className="btn btn-link">
                                                Link
                                            </button>
                                            <button type="button" className="btn btn-white">
                                                white
                                            </button>
                                        </p>

                                        <p>
                                            <button type="button" className="btn btn-primary" disabled>
                                                Primary
                                            </button>
                                            <button type="button" className="btn btn-secondary" disabled>
                                                Secondary
                                            </button>
                                            <button type="button" className="btn btn-success" disabled>
                                                Success
                                            </button>
                                            <button type="button" className="btn btn-info" disabled>
                                                Info
                                            </button>
                                            <button type="button" className="btn btn-warning" disabled>
                                                Warning
                                            </button>
                                            <button type="button" className="btn btn-danger" disabled>
                                                Danger
                                            </button>
                                            <button type="button" className="btn btn-light" disabled>
                                                Light
                                            </button>
                                            <button type="button" className="btn btn-dark" disabled>
                                                Dark
                                            </button>
                                            <button type="button" className="btn btn-link" disabled>
                                                Link
                                            </button>
                                        </p>

                                        <p>
                                            <button type="button" className="btn btn-outline-primary">
                                                Primary
                                            </button>
                                            <button type="button" className="btn btn-outline-secondary">
                                                Secondary
                                            </button>
                                            <button type="button" className="btn btn-outline-success">
                                                Success
                                            </button>
                                            <button type="button" className="btn btn-outline-info">
                                                Info
                                            </button>
                                            <button type="button" className="btn btn-outline-warning">
                                                Warning
                                            </button>
                                            <button type="button" className="btn btn-outline-danger">
                                                Danger
                                            </button>
                                            <button type="button" className="btn btn-outline-light">
                                                Light
                                            </button>
                                            <button type="button" className="btn btn-outline-dark">
                                                Dark
                                            </button>
                                        </p>

                                        <p>
                                            <div
                                                className="btn-group"
                                                role="group"
                                                aria-label="Button group with nested dropdown"
                                            >
                                                <button type="button" className="btn btn-primary">
                                                    Primary
                                                </button>
                                                <div className="btn-group" role="group">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary dropdown-toggle"
                                                        data-bs-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    />
                                                    <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className="btn-group"
                                                role="group"
                                                aria-label="Button group with nested dropdown"
                                            >
                                                <button type="button" className="btn btn-success">
                                                    Success
                                                </button>
                                                <div className="btn-group" role="group">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success dropdown-toggle"
                                                        data-bs-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    />
                                                    <div className="dropdown-menu" aria-labelledby="btnGroupDrop2">
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className="btn-group"
                                                role="group"
                                                aria-label="Button group with nested dropdown"
                                            >
                                                <button type="button" className="btn btn-info">
                                                    Info
                                                </button>
                                                <div className="btn-group" role="group">
                                                    <button
                                                        type="button"
                                                        className="btn btn-info dropdown-toggle"
                                                        data-bs-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    />
                                                    <div className="dropdown-menu" aria-labelledby="btnGroupDrop3">
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className="btn-group"
                                                role="group"
                                                aria-label="Button group with nested dropdown"
                                            >
                                                <button type="button" className="btn btn-danger">
                                                    Danger
                                                </button>
                                                <div className="btn-group" role="group">
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger dropdown-toggle"
                                                        data-bs-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    />
                                                    <div className="dropdown-menu" aria-labelledby="btnGroupDrop4">
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                        <a className="dropdown-item" href="#">
                                                            Dropdown link
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </p>

                                        <p>
                                            <button type="button" className="btn btn-primary btn-lg">
                                                Large button
                                            </button>
                                            <button type="button" className="btn btn-primary">
                                                Default button
                                            </button>
                                            <button type="button" className="btn btn-primary btn-sm">
                                                Small button
                                            </button>
                                        </p>

                                        <p>
                                            <button className="btn btn-primary btn-block" type="button">
                                                Block button
                                            </button>
                                            <button className="btn btn-lg btn-primary btn-block" type="button">
                                                Block button
                                            </button>
                                        </p>

                                        <p>
                                            <div className="btn-group btn-group-toggle" data-toggle="buttons">
                                                <label className="btn btn-secondary active">
                                                    <input type="radio" name="options" checked /> Active
                                                </label>
                                                <label className="btn btn-secondary">
                                                    <input type="radio" name="options" /> Radio
                                                </label>
                                                <label className="btn btn-secondary">
                                                    <input type="radio" name="options" /> Radio
                                                </label>
                                            </div>
                                        </p>

                                        <p>
                                            <div
                                                className="btn-toolbar"
                                                role="toolbar"
                                                aria-label="Toolbar with button groups"
                                            >
                                                <div className="btn-group mr-2" role="group" aria-label="First group">
                                                    <button type="button" className="btn btn-secondary">
                                                        1
                                                    </button>
                                                    <button type="button" className="btn btn-secondary">
                                                        2
                                                    </button>
                                                    <button type="button" className="btn btn-secondary">
                                                        3
                                                    </button>
                                                    <button type="button" className="btn btn-secondary">
                                                        4
                                                    </button>
                                                </div>
                                                <div className="btn-group mr-2" role="group" aria-label="Second group">
                                                    <button type="button" className="btn btn-secondary">
                                                        5
                                                    </button>
                                                    <button type="button" className="btn btn-secondary">
                                                        6
                                                    </button>
                                                    <button type="button" className="btn btn-secondary">
                                                        7
                                                    </button>
                                                </div>
                                                <div className="btn-group" role="group" aria-label="Third group">
                                                    <button type="button" className="btn btn-secondary">
                                                        8
                                                    </button>
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tabId="ht3">
                            <div className="container my-4">
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label>Normal Table</label>
                                            <table className="table table-borderless table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">First</th>
                                                        <th scope="col">Last</th>
                                                        <th scope="col">Handle</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">1</th>
                                                        <td>Mark</td>
                                                        <td>Otto</td>
                                                        <td>@mdo</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">2</th>
                                                        <td>Jacob</td>
                                                        <td>Thornton</td>
                                                        <td>@fat</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">3</th>
                                                        <td>Larry</td>
                                                        <td>the Bird</td>
                                                        <td>@twitter</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">4</th>
                                                        <td>Larry</td>
                                                        <td>the Bird</td>
                                                        <td>@twitter</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">2</th>
                                                        <td>Jacob</td>
                                                        <td>Thornton</td>
                                                        <td>@fat</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="form-group">
                                            <label>React Table</label>
                                            <ReactTable
                                                noDataText={"No hay datos..."}
                                                loadingText={"Cargando..."}
                                                rowsText={"filas"}
                                                ofText={"de"}
                                                previousText={"Anterior"}
                                                nextText={"Siguiente"}
                                                pageText={"Página"}
                                                columns={[
                                                    {
                                                        Header: "#",
                                                        accessor: "id",
                                                        Cell: row => {
                                                            return <strong>{row.index + 1}</strong>;
                                                        },
                                                        width: 100,
                                                        filterable: false,
                                                        sortable: false,
                                                        minResizeWidth: 10,
                                                    },
                                                    {
                                                        Header: "First",
                                                        accessor: "first",
                                                        minResizeWidth: 10,
                                                    },
                                                    {
                                                        Header: "Last",
                                                        accessor: "last",
                                                        minResizeWidth: 10,
                                                    },
                                                    {
                                                        Header: "Handle",
                                                        accessor: "handle",
                                                        minResizeWidth: 10,
                                                    },
                                                ]}
                                                manual
                                                data={[
                                                    { id: 1, first: "Mark", last: "Otto", handle: "@mdo" },
                                                    { id: 2, first: "Mark", last: "Otto", handle: "@mdo" },
                                                    { id: 3, first: "Mark", last: "Otto", handle: "@mdo" },
                                                    { id: 4, first: "Mark", last: "Otto", handle: "@mdo" },
                                                    { id: 5, first: "Mark", last: "Otto", handle: "@mdo" },
                                                ]}
                                                pages={5}
                                                loading={false}
                                                onFetchData={() => null}
                                                defaultPageSize={5}
                                                filterable
                                                className="-striped -highlight"
                                            ></ReactTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                    </TabContent>
                </CardBody>
                <CardFooter>
                    <button type="button" className="btn btn-primary mr-2" onClick={toggle}>
                        Show Modal
                    </button>
                    <button
                        type="button"
                        className="btn btn-success mr-2"
                        onClick={() => alert.current.show_info("Mensaje de prueba")}
                    >
                        Show Alert
                    </button>
                </CardFooter>
            </Card>

            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>Modal title</ModalHeader>
                <ModalBody>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum.
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-secondary" onClick={toggle}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-primary ml-auto" onClick={toggle}>
                        Do Something
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    );
};
